(function () {
  var debug_console = document.getElementById("debug_console");
  if (!debug_console) {
    return;
  }

  var debug_console__input_open = document.getElementById("debug_console__input_open");
  var debug_console__input_shrink = document.getElementById("debug_console__input_shrink");
  var debug_console__window_width = document.getElementById("debug_console__window_width");
  var debug_console__window_height = document.getElementById("debug_console__window_height");
  var debug_console__screen_width = document.getElementById("debug_console__screen_width");
  var debug_console__screen_height = document.getElementById("debug_console__screen_height");
  var debug_console__pixel_ratio = document.getElementById("debug_console__pixel_ratio");
  var debug_console__url = document.getElementById("debug_console__url");
  var debug_console__log = document.getElementById("debug_console__log");
  var debug_console__inner = debug_console.querySelector(".debug_console__inner");

  var nativeConsole = {
    log: (typeof console.log === "function" ? console.log.bind(console) : function () {}),
    info: (typeof console.info === "function" ? console.info.bind(console) : function () {}),
    warn: (typeof console.warn === "function" ? console.warn.bind(console) : function () {}),
    error: (typeof console.error === "function" ? console.error.bind(console) : function () {})
  };
  var consoleHookGuard = false;
  var debugLogLast = ["", "", ""];
  var levelText = [
    ["", "Info: ", "Warning: ", "Error: "],
    ["", "debug-info", "debug-warn", "debug-error"]
  ];
  var levelIconClass = [
    null,
    ["debug-icon", "font-icon--example-debug-console--info", "font-icon--color--example-debug-console--info"],
    ["debug-icon", "font-icon--example-debug-console--warning", "font-icon--color--example-debug-console--warning"],
    ["debug-icon", "font-icon--example-debug-console--error", "font-icon--color--example-debug-console--error"]
  ];

  function hasClass(element, className) {
    return !!element && element.classList.contains(className);
  }

  function toggleClass(element, className) {
    if (element) {
      element.classList.toggle(className);
    }
  }

  function addElement(parent, tagName, classNames, text) {
    var node = document.createElement(tagName);
    if (classNames) {
      if (Array.isArray(classNames)) {
        for (var i = 0; i < classNames.length; i++) {
          if (classNames[i]) {
            node.classList.add(classNames[i]);
          }
        }
      } else {
        node.className = classNames;
      }
    }
    if (text !== undefined) {
      node.textContent = text;
    }
    parent.appendChild(node);
    return node;
  }

  function addElementBefore(referenceNode, tagName, classNames, text) {
    var node = document.createElement(tagName);
    if (classNames) {
      if (Array.isArray(classNames)) {
        for (var i = 0; i < classNames.length; i++) {
          if (classNames[i]) {
            node.classList.add(classNames[i]);
          }
        }
      } else {
        node.className = classNames;
      }
    }
    if (text !== undefined) {
      node.textContent = text;
    }
    referenceNode.parentNode.insertBefore(node, referenceNode);
    return node;
  }

  function isDebugConsoleEntryNew(idx, newer) {
    var isNew = newer !== debugLogLast[idx];
    if (isNew) {
      debugLogLast[idx] = newer;
    }
    return isNew;
  }

  function updateLogEmptyState() {
    if (!debug_console__log) {
      return;
    }

    var emptyNode = debug_console__log.querySelector(".debug_console__log__empty");
    var count = debug_console__log.children.length;
    var hasOnlyEmpty = emptyNode && count === 1;
    var hasRealEntries = count > 0 && !hasOnlyEmpty;

    if (hasRealEntries) {
      if (emptyNode) {
        emptyNode.remove();
      }
      return;
    }

    if (!emptyNode) {
      addElement(debug_console__log, "li", ["debug_console__log__empty", "clearfix"], "No log entries yet.");
    }
  }

  function isLogPinnedToBottom() {
    if (!debug_console__inner) {
      return false;
    }
    var threshold = 4;
    return (debug_console__inner.scrollTop + debug_console__inner.clientHeight) >= (debug_console__inner.scrollHeight - threshold);
  }

  function scrollLogToBottom() {
    if (debug_console__inner) {
      debug_console__inner.scrollTop = debug_console__inner.scrollHeight;
    }
  }

  function parseStack(stack, frameOffset) {
    var lines = String(stack || "").split("\n");
    var pattern = /((?:https?|file):\/\/[^\s\)]+):(\d+):(\d+)/i;
    var matches = [];

    for (var i = 0; i < lines.length; i++) {
      var match = lines[i].match(pattern);
      if (match) {
        matches.push(match);
      }
    }

    if (matches.length > 0) {
      var selectedIndex = Math.min(Math.max(frameOffset || 0, 0), matches.length - 1);
      var selected = matches[selectedIndex];
      var fullUrl = selected[1];
      var slashIndex = fullUrl.lastIndexOf("/");
      var debugPath = slashIndex >= 0 ? fullUrl.substring(0, slashIndex + 1) : (window.location.origin + "/");
      var debugFile = slashIndex >= 0 ? fullUrl.substring(slashIndex + 1) : fullUrl;
      return ["", debugPath, debugFile, selected[2], selected[3]];
    }

    return ["", window.location.origin + "/", "inline", "0", "0"];
  }

  function debug_console_process(level, message, stack, stackFrameOffset) {
    var keepPinned = isLogPinnedToBottom();
    var debugMessage = "<span class='debug_console__log__entry__details__level'>" + levelText[0][level] + "</span>" + message;
    var parsed = parseStack(stack, stackFrameOffset);
    var debugPath = parsed[1];
    var debugFile = parsed[2];
    var debugLineNum = parsed[3];
    var debugColNum = parsed[4];
    var debugLoc = debugLineNum + ":" + debugColNum;

    if (isDebugConsoleEntryNew(0, debugMessage)) {
      var existingEmpty = debug_console__log.querySelector(".debug_console__log__empty");
      if (existingEmpty) {
        existingEmpty.remove();
      }

      var newFile = isDebugConsoleEntryNew(1, debugFile);
      var entryClasses = [];

      if (!newFile) {
        entryClasses.push("debugconsole-samefile");
      }
      if (levelText[1][level] !== "") {
        entryClasses.push(levelText[1][level]);
      }
      entryClasses.push("clearfix");

      var entry = addElement(debug_console__log, "li", entryClasses);
      var details = addElement(entry, "span", "debug_console__log__entry__details");

      if (newFile) {
        var debugLink = addElement(details, "a", ["debug_console__log__entry__details__location", "debug_console__log__entry__details__location--file"], debugFile);
        debugLink.href = debugPath + debugFile;
        addElement(details, "span", ["debug_console__log__entry__details__location", "debug_console__log__entry__details__location--file"], ": ");
      }
      addElement(details, "span", "debug_console__log__entry__details__location", debugLoc);

      if (levelIconClass[level]) {
        var levelIcon = addElement(entry, "span", levelIconClass[level]);
        levelIcon.setAttribute("aria-hidden", "true");
      }

      var text = addElement(entry, "span", "debug-text");
      text.innerHTML = debugMessage;
    } else {
      var lastEntry = debug_console__log.lastElementChild;
      if (lastEntry) {
        var target = lastEntry.getElementsByClassName("debug_console__log__entry__details__count")[0];
        if (target === undefined) {
          var loc = lastEntry.getElementsByClassName("debug_console__log__entry__details__location")[0];
          if (loc) {
            addElementBefore(loc, "span", "debug_console__log__entry__details__count", "2");
          }
        } else {
          var content = parseInt(target.textContent, 10);
          target.textContent = String((!isNaN(content) ? content : 1) + 1);
        }
      }
    }

    updateLogEmptyState();
    if (keepPinned) {
      scrollLogToBottom();
    }
    return [message];
  }

  function formatConsoleArg(value) {
    if (typeof value === "string") {
      return value;
    }
    if (value instanceof Error) {
      return value.message;
    }
    try {
      return JSON.stringify(value);
    } catch (error) {
      return String(value);
    }
  }

  function hookConsoleMethod(methodName, level) {
    if (typeof console[methodName] !== "function") {
      return;
    }

    console[methodName] = function () {
      var args = Array.prototype.slice.call(arguments);
      if (!consoleHookGuard) {
        consoleHookGuard = true;
        try {
          var message = args.map(formatConsoleArg).join(" ");
          debug_console_process(level, message, (new Error()).stack, 1);
        } finally {
          consoleHookGuard = false;
        }
      }
      return nativeConsole[methodName].apply(console, args);
    };
  }

  function hookConsole() {
    if (window.__debugConsoleHookInstalled) {
      return;
    }
    window.__debugConsoleHookInstalled = true;
    hookConsoleMethod("log", 0);
    hookConsoleMethod("info", 1);
    hookConsoleMethod("warn", 2);
    hookConsoleMethod("error", 3);
  }

  function hookGlobalErrors() {
    if (window.__debugConsoleErrorHooksInstalled) {
      return;
    }
    window.__debugConsoleErrorHooksInstalled = true;

    var previousOnError = window.onerror;
    window.onerror = function (message, source, lineno, colno, error) {
      var parts = ["Uncaught error:", formatConsoleArg(message)];
      if (source) {
        parts.push("at", source + ":" + (lineno || 0) + ":" + (colno || 0));
      }
      if (error && error.stack) {
        parts.push("(" + formatConsoleArg(error.stack) + ")");
      }
      debug_console_process(3, parts.join(" "), (error && error.stack) || (new Error()).stack);

      if (typeof previousOnError === "function") {
        return previousOnError.apply(this, arguments);
      }
      return false;
    };

    window.addEventListener("unhandledrejection", function (event) {
      var reason = event && event.reason;
      var message = "Unhandled promise rejection: " + formatConsoleArg(reason);
      var stack = (reason && reason.stack) ? reason.stack : (new Error()).stack;
      debug_console_process(3, message, stack);
    });
  }

  function amendButton(buttonSelect, buttonText, altTitle) {
    if (!buttonSelect) {
      return;
    }
    buttonSelect.textContent = buttonText;
    buttonSelect.title = (altTitle !== undefined ? altTitle : buttonText) + " Debug Console";
  }

  function debug_console_update_stat(element, text) {
    if (element && element.textContent !== String(text)) {
      element.textContent = String(text);
    }
  }

  function debug_console_update_stats_screen() {
    debug_console_update_stat(debug_console__screen_width, window.innerWidth);
    debug_console_update_stat(debug_console__screen_height, window.innerHeight);
    debug_console_update_stat(debug_console__pixel_ratio, window.devicePixelRatio);
  }

  function debug_console_update_stats_viewport() {
    debug_console_update_stat(debug_console__window_width, window.screen.width);
    debug_console_update_stat(debug_console__window_height, window.screen.height);
  }

  function debug_console_resize() {
    debug_console_update_stats_screen();
    debug_console_update_stats_viewport();
  }

  function debug_console_init() {
    var url = window.location;
    var html = "<span class=\"debug_console__url__protocol\">" + url.protocol + "</span>//";
    html += "<span class=\"debug_console__url__hostname\">" + url.hostname + "</span>";
    if (url.port) {
      html += ":<span class=\"debug_console__url__port\">" + url.port + "</span>";
    }
    html += "<span class=\"debug_console__url__pathname\">" + url.pathname + "</span>";
    if (url.search) {
      html += "<span class=\"debug_console__url__search\">" + url.search + "</span>";
    }
    if (url.hash) {
      html += "<span class=\"debug_console__url__hash\">" + url.hash + "</span>";
    }
    debug_console__url.innerHTML = html;
  }

  function queueRefreshFrame() {
    setTimeout(function () {
      document.dispatchEvent(new CustomEvent("refreshFrame"));
      document.dispatchEvent(new CustomEvent("refreshStickyLayout"));
    }, 500);
  }

  function clearLogs() {
    debug_console__log.innerHTML = "";
    debugLogLast = ["", "", ""];
    updateLogEmptyState();
  }

  if (debug_console__input_open) {
    debug_console__input_open.addEventListener("click", function (event) {
      event.preventDefault();
      toggleClass(debug_console, "opened");
      if (hasClass(debug_console, "opened")) {
        amendButton(debug_console__input_open, "X", "Close");
      } else {
        amendButton(debug_console__input_open, "Open");
      }
      queueRefreshFrame();
      return false;
    });
  }

  if (debug_console__input_shrink) {
    debug_console__input_shrink.addEventListener("click", function (event) {
      event.preventDefault();
      if (hasClass(debug_console, "opened")) {
        toggleClass(debug_console, "shrunk");
      }
      if (hasClass(debug_console, "shrunk")) {
        amendButton(debug_console__input_shrink, "Expand");
      } else {
        amendButton(debug_console__input_shrink, "Shrink");
      }
      queueRefreshFrame();
      return false;
    });
  }

  window.addEventListener("resize", function () {
    debug_console_resize();
  });
  window.addEventListener("orientationchange", function () {
    debug_console_resize();
  });

  var debug_console_poll_interval = window.setInterval(function () {
    debug_console_resize();
  }, 1000);

  window.addEventListener("beforeunload", function () {
    window.clearInterval(debug_console_poll_interval);
  });

  debug_console_init();
  debug_console_resize();
  updateLogEmptyState();
  hookConsole();
  hookGlobalErrors();

  window.DebugPanelCore = {
    clearLogs: clearLogs
  };
})();
